import { EtaDistanceResult, EtaLocation } from '@/feature/eta'
import { GEO_FEATURE_MARKER_COLOR, HIGH_RISK_MARKER_COLOR } from '@/feature/observatory'

import { MarkerBadge } from '@/components/MarkerBadge'
import { LuBolt, LuTriangleAlert } from 'react-icons/lu'
import { Loader } from '@/lib/core/components/Loader'

import { LocationToContent } from '../LocationToContent'
import { LocationToError } from '../LocationToError'
import styles from '../Eta.module.css'

export const GeoFenceLocationTo = ({
  etaLocation,
  etaResult,
  error,
}: {
  etaLocation: EtaLocation
  etaResult?: EtaDistanceResult
  error?: string
}) => (
  <div className={styles.locationTo}>
    <div className={styles.locationToHeader}>
      {etaLocation.highRiskArea ? (
        <MarkerBadge glyph={LuTriangleAlert} color={HIGH_RISK_MARKER_COLOR} size={28} />
      ) : (
        <div className={styles.geoFenceIcon}>
          <MarkerBadge glyph={LuBolt} size={22} color={GEO_FEATURE_MARKER_COLOR} />
        </div>
      )}
      <div>{etaLocation.title}</div>
    </div>
    {error ? (
      <LocationToError error={error} />
    ) : etaResult ? (
      <LocationToContent etaResult={etaResult} />
    ) : (
      <div className={styles.locationToLoading}>
        <Loader style={{ padding: '1.25rem' }} />
      </div>
    )}
  </div>
)
